import { format } from 'date-fns';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { Button } from '../Button/Button.esm.js';
import 'tslib';
import '@panwds/icons';
import '@popperjs/core';
import '../Icon/ImgIcon.esm.js';
import '../Icon/FaIcon.esm.js';
import '../Icon/SemanticIcons.esm.js';
import '../Button/ProgressButton.esm.js';
import '../Button/CopyButton.esm.js';
import { Popover } from '../Popover/Popover.esm.js';
import '../Tooltip/Tooltip.esm.js';
import '../../utils/constants.esm.js';
import { DatePicker } from './DatePicker.esm.js';

/**
 * Select a date.
 *
 * `DatePickerDialog` is the most common interaction and should work out of the box for most use cases. If you need something a bit
 * different, use the lower-level components `DatePicker`, `Calendar`, and/or `DateInput` to customize the interaction.
 *
 * ### Import Guide
 *
 * ```jsx
 * import { DatePickerDialog } from "@panwds/react-ui";
 * ```
 */
var DatePickerDialog = function (_a) {
    var button = _a.button, dataMetrics = _a.dataMetrics, dataTestId = _a.dataTestId, label = _a.label, _b = _a.dateFormat, dateFormat = _b === void 0 ? "PP" : _b, _c = _a.defaultPlacement, defaultPlacement = _c === void 0 ? "bottom-start" : _c, _d = _a.fullWidth, fullWidth = _d === void 0 ? false : _d, max = _a.max, min = _a.min, onApply = _a.onApply, selectedDate = _a.selectedDate, showLabel = _a.showLabel, weekStartsOn = _a.weekStartsOn;
    var intl = useIntl();
    var _e = useState(false), isOpen = _e[0], setIsOpen = _e[1];
    return (React.createElement(Popover, { dataMetrics: dataMetrics, dataTestId: dataTestId || "date-picker-dialog", button: button || (React.createElement(Button, { fullWidth: fullWidth, isMenu: true }, format(selectedDate, dateFormat))), defaultPlacement: defaultPlacement, label: label !== null && label !== void 0 ? label : intl.formatMessage({ id: "4Mab4D", defaultMessage: [{ type: 0, value: "Select a date" }] }), showLabel: showLabel, isOpen: isOpen, onIsOpenChange: setIsOpen },
        React.createElement(DatePicker, { initialDate: selectedDate, max: max, min: min, onApply: function (nextDate) {
                onApply(nextDate);
                setIsOpen(false);
            }, onCancel: function () { return setIsOpen(false); }, weekStartsOn: weekStartsOn })));
};

export { DatePickerDialog };
//# sourceMappingURL=DatePickerDialog.esm.js.map
